// extracted by mini-css-extract-plugin
export default {"badge":"components-hotel-channel-pricing-tables-cells-channels-table-td-channels-table-name-cell-module__badge"};